import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export const LOCALES = ["cs", "sk", "de", "de-AT", "en", "pl"];

// If you would like to switch to production locales in development env:
// const DEVELOPMENT = false
const DEVELOPMENT = import.meta.env.MODE === "development";
const LOCALE_RESOURCE = DEVELOPMENT ? "base" : "translations/{{lng}}";

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		fallbackLng: "cs",
		supportedLngs: LOCALES,
		debug: DEVELOPMENT,
		backend: {
			loadPath: `/locales/${LOCALE_RESOURCE}.json`,
		},
		interpolation: {
			escapeValue: false, // not needed for react as it escapes by default
		},
	});

export default i18n;
